<template>
  <el-input
    :value="displayText"
    readonly
    class="idcard-masked-input"
  >
    <i
      v-if="value"
      slot="suffix"
      :class="['el-input__icon', 'el-icon-view', 'idcard-eye', { 'is-visible': visible }]"
      :title="visible ? '隐藏' : '显示'"
      @click.stop="visible = !visible"
    />
  </el-input>
</template>

<script>
import { maskIdCard } from '../utils/idcard.js';

export default {
  name: 'IdCardMasked',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    displayText() {
      if (!this.value) return '';
      return this.visible ? this.value : maskIdCard(this.value);
    },
  },
};
</script>

<style scoped>
.idcard-masked-input >>> .el-input__inner {
  letter-spacing: 1px;
}

.idcard-eye {
  cursor: pointer;
  color: #909399;
  transition: color 0.2s ease;
}

.idcard-eye:hover,
.idcard-eye.is-visible {
  color: #1e4d8c;
}
</style>



// WEBPACK FOOTER //
// src/components/IdCardMasked.vue